import api from './api';

export const getTrackingSettings = () => api.get('/tracking/settings');
export const updateTrackingSettings = (data) => api.put('/tracking/settings', data);

export const createTrackingStage = (data) => api.post('/tracking/stages', data);
export const updateTrackingStage = (id, data) => api.put(`/tracking/stages/${id}`, data);
export const deleteTrackingStage = (id) => api.delete(`/tracking/stages/${id}`);
export const reorderTrackingStages = (order) => api.put('/tracking/stages/reorder', { order });

export const updateTrackingStatusMapping = (mapping) => api.put('/tracking/status-mapping', { mapping });
